module.exports = __webpack_public_path__ + "static/prodinity_main_9-e8817dd169fa2ea453e94c24d3df0c63.png";